import api from '../api/city';
import config from 'config';
let { loginDomain } = config;

export default {
    getCityForumPv: payload => {
        return api.getCityForumPv({
            topicId: payload
        }).then(data => {
            // console.log(data);
            return data;
        })
    },
    getCityFeed: payload => {
        return api.getCityFeed(payload)
    },
    getCityListData: payload => {
        return api.getCityListData(payload)
    },
    // getMessageCode: (domain, payload) => {
    //     let url = '//login.' + domain + '.cn/captcha/secure/getMobileCaptcha?';
    //     for(let x in payload){
    //         if(payload.hasOwnProperty(x)){
    //             url = url + x + '=' + payload[x] + '&';
    //         }
    //     }
    //     url = url.substr(0, url.length - 1);
    //     return api.getMessageCode(url)
    // },
    getMessageCode: (domain, payload) => {
        // let url = loginDomain + '/captcha/secure/getMobileCaptcha?';
        let url = '//login.' + domain + '.cn/captcha/secure/getMobileCaptcha?';
        return api.getMessageCode(url, payload)
    },
    sendCondoTourInfo: payload => {
        return api.sendCondoTourInfo(payload)
    },
    getIndexFurnishing: payload => {
        return api.getIndexFurnishing(payload)
    },
    getIndexRentHouse: payload => {
        return api.getIndexRentHouse(payload)
    },
    getUserInfo: (domain) => {
        // let url = loginDomain + '/passport/getUserInfo?' + Math.random();
        let url = '//login.' + domain + '.cn/passport/getUserInfo?' + Math.random();
        return api.getUserInfo(url)
    }
}



// WEBPACK FOOTER //
// ./src/model/service/cityIndex.js